<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">{{'Copyright' | translate}} {{ today | date:'y'}} {{'© Cielo powered by 12 Skies Tech'| translate}}</p>
    </div>
  </div>
</div>